/* eslint-disable */
import dayjs from "dayjs";
import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { INTERNSHIP_TO_BE_EDIT, SET_CURRENT_EDIT_QUALIFICATION_INDEX } from "../../common/constants/ActionTypes";
import {
  AUTHOR_TYPES,
  BOOLEAN_OPTION,
} from "../../common/constants/dropdownOptions";
import commonLabels from "../../my_account/labels/common_en.json";
import "../../styles/advertisementTable.css";
import "../../styles/qualification.css";
import {
  deleteInternship,
  deleteQualification,
  getAllNameOfIndexingBodies,
  getAllPublicationArticleTypes,
  getDetailsForEditInternship,
  getDetailsForEditQualification,
  getDisplayableQualificationList,
  getPublicationTypeData,
  getQualificationDetails,
  toggleAndSetEditing,
} from "../actions/profileAction";
import common from "../labels/common_en.json";
import qualificationinformation from "../labels/qualification_information_en.json";
import qualificationinformation_hindi from "../labels/qualification_information_hin.json";

import { PiDotsThreeOutlineVerticalFill } from "react-icons/pi";
import { SUBJECTS } from "../../common/constants/endpoints";
import API from "../../helpers/API";
import {
  articleType,
  authorType,
  isPublicationFirstAuthor,
  nameOfIndexingBodies
} from "../../helpers/LookupOptionHelper";
import "../../styles/qualification.css";
import { SET_CURRENT_EDIT_INTERNSHIP_INDEX } from './../../common/constants/ActionTypes';
import { getFormattedDate } from "../../helpers/Datetime";

const QualificationTabTable = ({ activeQualificationIndex, activeIntershipIndex, activePublicationIndex, setActiveQualificationIndex, setActiveIntershipIndex, setActivePublicationIndex, enableEditProfileWithLock }) => {
  let {
    profileStatus,
    qualificationsList,
    displayableQualificationList,
    internshipList,
    qualificationTypes,
    nameOfIndexingBodiesList,
    getPublicationArticleTypeList,
    subjects,
    isEditing,
    isEditingIndex,
    editIndex,
    buttonsVisible,
    setToggleEditMode,
    internshipToBeEditedForm
  } = useSelector((state) => state.profile, shallowEqual);


  const dispatch = useDispatch();
  let [showModal, setShowModal] = useState(false);
  let [internShowModal, setInternShowModal] = useState(false);
  let [deleteIndex, setDeleteIndex] = useState("");
  let [qualificationSortList, setQualificationSortList] = useState([]);
  let [showPublicationTable, setShowPublicationTable] = useState(false);
  let [showInternshipTable, setShowInternshipTable] = useState(false);
  const [buttons, setButtons] = useState(buttonsVisible);
  const [deleteInternIndex, setDeleteInternIndex] = useState("")


  let count = 0;
  let publicationTableCount = 0;
  let internshipCount = 0;

  useEffect(() => {
    dispatch(getDisplayableQualificationList(qualificationsList));

    if (qualificationsList) {
      const hasPbQualification = qualificationsList.some(
        (item) => item.qualificationtypecode === "Pb"
      );
      setShowPublicationTable(hasPbQualification);

      const hasinternshipQualification = qualificationsList.some(
        (item) => item.qualificationtypecode === "Internship"
      );
      (internshipList.length > 0 && setShowInternshipTable(true));
    }
  }, [qualificationsList, internshipList]);



  useEffect(() => {
    dispatch(getAllNameOfIndexingBodies());
    dispatch(getAllPublicationArticleTypes());
  }, []);



  useEffect(() => {
    let list = [];
    qualificationTypes.forEach(
      (qualfn, index) => (list[index] = qualfn.qualificationtypecode)
    );
    setQualificationSortList(list);
  }, [qualificationTypes, displayableQualificationList]);

  let deleteQualificationRow = (qualificationRowIndex) => {
    dispatch(deleteQualification(qualificationRowIndex, qualificationsList));
  };



  let deleteInternshipRow = (internshipId) => {
    dispatch(deleteInternship(internshipId, internshipList));
  };

  const checkNumberOrNot = (inputString) => {
    let parts;

    if (Array.isArray(inputString)) {
      parts = inputString;
    } else if (typeof inputString === "string") {
      parts = inputString.split(",");
    } else {
      console.error("Invalid inputString type. Expected a string or array.");
      return false;
    }

    const isNumberArray = parts.map((part) => {
      if (typeof part !== "string") part = String(part);
      return !isNaN(Number(part.trim()));
    });

    const isNumber = isNumberArray.every((result) => result);
    return isNumber;
  };

  let editQualificationRow = async (qualificationRowIndex, ele) => {

    try {
      let subjectsArrList = subjects;
      if (ele && ele.id) {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response = await API.get(
          SUBJECTS +
          `?qualificationnamecode=${qualificationsList[qualificationRowIndex].qualificationnamecode}`,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        subjectsArrList = response && response.data;
      }

      let optionalSubjectsIsNumberFlg = false;
      let compulsorySubjectsIsNumberFlg = false;
      let optionalSubjectsIsNumberFlgValue = "";
      let compulsorySubjectsIsNumberFlgValue = "";

      // if (ele && ele.optionalSubjects) {
      //   let optionalSubjectsIsNumber = checkNumberOrNot(ele.optionalSubjects);

      //   if (!optionalSubjectsIsNumber) {
      //     optionalSubjectsIsNumberFlg = false;
      //     optionalSubjectsIsNumberFlgValue = ele.optionalSubjects;
      //   }
      // }

      // if (ele && ele.compulsorySubjects) {
      //   let compulsorySubjectsIsNumber = checkNumberOrNot(
      //     ele.compulsorySubjects
      //   );
      //   if (!compulsorySubjectsIsNumber) {
      //     compulsorySubjectsIsNumberFlg = false;
      //     compulsorySubjectsIsNumberFlgValue = ele.compulsorySubjects;
      //   }
      // }

      dispatch({
        type: SET_CURRENT_EDIT_QUALIFICATION_INDEX,
        payload: qualificationRowIndex,
      });
      if (ele.qualificationtypecode === "Pb") {
        dispatch(getPublicationTypeData("Pb"));
      }
      if (
        qualificationsList[qualificationRowIndex].compulsorySubjects ||
        qualificationsList[qualificationRowIndex].optionalSubjects
      ) {
        // const subjectIdsArray = qualificationsList[
        //   qualificationRowIndex
        // ].compulsorySubjects.includes(",")
        //   ? qualificationsList[qualificationRowIndex].compulsorySubjects.split(
        //     ","
        //   )
        //   : [qualificationsList[qualificationRowIndex].compulsorySubjects];
        // const matchingSubjects =
        //   subjectsArrList &&
        //   subjectsArrList.length > 0 &&
        //   subjectsArrList.filter((item) =>
        //     subjectIdsArray.includes(item.subjectId.toString())
        //   );
        const qualification = qualificationsList[qualificationRowIndex];
        const compulsorySubjects =
          qualification && qualification.compulsorySubjects
            ? qualification.compulsorySubjects
            : "";

        const subjectIdsArray = compulsorySubjects.includes(",")
          ? compulsorySubjects.split(",")
          : compulsorySubjects
            ? [compulsorySubjects]
            : [];

        const matchingSubjects =
          subjectsArrList?.length > 0
            ? subjectsArrList.filter((item) =>
              subjectIdsArray.includes(item.subjectId.toString())
            )
            : [];

        const optionalSubjectsQualification = qualificationsList[qualificationRowIndex];
        const optionalSubjects =
          optionalSubjectsQualification && optionalSubjectsQualification.optionalSubjects
            ? optionalSubjectsQualification.optionalSubjects
            : "";

        const optionalSubjectIdsArray = optionalSubjects.includes(",")
          ? optionalSubjects.split(",")
          : optionalSubjects
            ? [optionalSubjects]
            : [];

        const matchingOptionalSubjects =
          subjectsArrList?.length > 0
            ? subjectsArrList.filter((item) =>
              optionalSubjectIdsArray.includes(item.subjectId.toString())
            )
            : [];

        // const optionalSubjectIdsArray = qualificationsList[
        //   qualificationRowIndex
        // ].optionalSubjects.includes(",")
        //   ? qualificationsList[qualificationRowIndex].optionalSubjects.split(
        //     ","
        //   )
        //   : [qualificationsList[qualificationRowIndex].optionalSubjects];

        // const matchingOptionalSubjects =
        //   subjectsArrList &&
        //   subjectsArrList.length > 0 &&
        //   subjectsArrList.filter((item) =>
        //     optionalSubjectIdsArray.includes(item.subjectId.toString())
        //   );

        let qualificationToBeEdited = qualificationsList[qualificationRowIndex];
        qualificationToBeEdited.compulsorySubjects = matchingSubjects;
        qualificationToBeEdited.optionalSubjects = matchingOptionalSubjects;
        qualificationToBeEdited.optionalSubjectsIsNumberFlg =
          optionalSubjectsIsNumberFlg;
        qualificationToBeEdited.compulsorySubjectsIsNumberFlg =
          compulsorySubjectsIsNumberFlg;
        qualificationToBeEdited.optionalSubjectsIsNumberFlgValue =
          optionalSubjectsIsNumberFlgValue;
        qualificationToBeEdited.compulsorySubjectsIsNumberFlgValue =
          compulsorySubjectsIsNumberFlgValue;

        dispatch(getDetailsForEditQualification(qualificationToBeEdited));
      } else {

        let qualificationToBeEdited = qualificationsList[qualificationRowIndex];

        qualificationToBeEdited.optionalSubjectsIsNumberFlg =
          optionalSubjectsIsNumberFlg;
        qualificationToBeEdited.compulsorySubjectsIsNumberFlg =
          compulsorySubjectsIsNumberFlg;
        qualificationToBeEdited.optionalSubjectsIsNumberFlgValue =
          optionalSubjectsIsNumberFlgValue;
        qualificationToBeEdited.compulsorySubjectsIsNumberFlgValue =
          compulsorySubjectsIsNumberFlgValue;
        dispatch(getDetailsForEditQualification(qualificationToBeEdited));
      }

      dispatch(toggleAndSetEditing(qualificationRowIndex, true, buttons)); // To enable currennt row and disable all other row for editing
    } catch (error) {
      console.error("Error fetching publication type data", error);
    }
  };



  let editInternshipRow = async (internshipId, ele) => {
    try {
      dispatch({
        type: SET_CURRENT_EDIT_INTERNSHIP_INDEX,
        payload: internshipId,
      });
      if (ele.subject === "Internship") {
        dispatch(getQualificationDetails());
      }
      let internshipToBeEdited = internshipList.filter((a) => a.id === internshipId);


      dispatch({
        type: INTERNSHIP_TO_BE_EDIT,
        payload: internshipToBeEdited
      })
      dispatch(getDetailsForEditInternship(internshipToBeEdited));

      dispatch(toggleAndSetEditing(internshipId, true, buttons)); // To enable currennt row and disable all other row for editing
    } catch (error) {
      console.error("Error fetching Internship data", error);
    }
  };












  const modalConfirm = () => {
    deleteQualificationRow(deleteIndex);
    setDeleteIndex("");
    setShowModal(false);
  };
  const modalConfirmInternship = () => {
    deleteInternshipRow(deleteInternIndex)
    setDeleteInternIndex("");
    setInternShowModal(false);
  };



  const sortQualificationList = (qualificationList) => {

    const sortedQualificationsArr = [
      "BSSC",
      "10th/Matric",
      "12th/Intermediate",
      "D",
      "Cf",
      "G",
      "CTET/CTET2/STET/STET2",
      "Specialised Subject/Subject Group in MBBS Examination",
      "PG Diploma",
      "PG",
      "NET/SLET/SET",
      "DM/MCH/DNB(Superspeciality)",
      "M.Phill",
      "PHD",
      "Ph.D Guide",
      "Associate",
      "AssociateMem",
      "Internship",
      "Fs",
      "MEMB",
      "Pb",
      "Other"
    ];
    if (
      displayableQualificationList &&
      Array.isArray(displayableQualificationList) &&
      displayableQualificationList.length > 0 &&
      qualificationList &&
      Array.isArray(qualificationList) &&
      qualificationList.length > 0
    ) {
      displayableQualificationList.sort(
        (a, b) =>
          sortedQualificationsArr.indexOf(a.qualificationtypecode) -
          sortedQualificationsArr.indexOf(b.qualificationtypecode)
      );
      return qualificationList.sort(
        (a, b) =>
          sortedQualificationsArr.indexOf(a.qualificationtypecode) -
          sortedQualificationsArr.indexOf(b.qualificationtypecode)
      );
    } else {
      return [];
    }
  };


  const qualificationInfoList =
    enableEditProfileWithLock?.editProfileWithLock == "1"
      ? enableEditProfileWithLock?.QualificationInfo?.split(",")
      : [];

  const canEdit = qualificationInfoList?.includes("U");
  const canDelete = qualificationInfoList?.includes("D");
  const showThreeDots = canEdit || canDelete;


  const internshipInfoList =
    enableEditProfileWithLock?.editProfileWithLock == "1"
      ? enableEditProfileWithLock?.Internship?.split(",")
      : [];

  const canEditIntership = internshipInfoList?.includes("U");
  const canDeleteIntership = internshipInfoList?.includes("D");
  const showThreeDotsIntership = canEditIntership || canDeleteIntership;


  return (
    <div className="border border-light">
      <div className="table-scroll-container">
        <table className="table table-bordered mb-4 freeze-table">
          <thead>
            <tr className="qualifcation_table">
              {qualificationinformation.qualificationHeaderContent &&
                qualificationinformation.qualificationHeaderContent.map(
                  (ele, index) => (
                    <th
                      scope="col"
                      key={index}
                      className={`theadBgColor_qualification ${index == 1 ? "sticky-col" : ""}`}
                    >
                      {ele}
                    </th>
                  )
                )}
            </tr>
          </thead>
          <tbody className="f12">
            {sortQualificationList(qualificationsList).map((ele, index) => {
              if ((!ele.isDelete && ele.qualificationtypecode !== "Pb" && ele.qualificationtypecode !== "Internship")) {
                count++;
                return (
                  <tr key={index}>

                    <td className="w-1 word-break text-center sticky-col">{count}</td>
                    <td className="word-break sticky-col">
                      {displayableQualificationList[index]
                        ? displayableQualificationList[index].qualificationTypeLabel
                        : "NA"}
                    </td>
                    <td className="word-break">
                      {displayableQualificationList[index]
                        ? displayableQualificationList[index].qualificationNameLabel
                        : "NA"}
                    </td>
                    <td className="word-break">
                      {displayableQualificationList[index] &&
                        displayableQualificationList[index].subjectLabel !== ""
                        ? displayableQualificationList[index].subjectLabel
                        : "NA"}
                    </td>
                    <td className="word-break">
                      {displayableQualificationList[index] &&
                        displayableQualificationList[index].universityOrBoardLabel !== ""
                        ? displayableQualificationList[index].universityOrBoardLabel
                        : "NA"}
                    </td>
                    <td className="word-break text-center">
                      {ele.resultDate
                        ? dayjs(getFormattedDate(ele.resultDate)).format(commonLabels.DATE_FORMAT)
                        : "NA"}
                    </td>
                    <td className="word-break text-center">
                      {ele.attempts || ele.attempts === 0 ? ele.attempts : "NA"}
                    </td>
                    <td className="word-break text-center">
                      {ele.obtainedMarks || ele.obtainedMarks == 0 ? ele.obtainedMarks : "NA"}
                    </td>
                    <td className="word-break text-center">
                      {ele.totalMarks || ele.totalMarks == 0 ? ele.totalMarks : "NA"}
                    </td>
                    <td className="word-break text-center">
                      {ele.percentageGrade ? ele.percentageGrade : "NA"}
                    </td>
                    <td className="word-break text-center">
                      {ele.courseDurationMonths ? ele.courseDurationMonths : "NA"}
                    </td>
                    <td className="word-break">
                      {displayableQualificationList[index] &&
                        displayableQualificationList[index].classGradeLabel !== ""
                        ? displayableQualificationList[index].classGradeLabel
                        : "NA"}
                    </td>
                    <td className="word-break">
                      {displayableQualificationList[index] &&
                        displayableQualificationList[index].modeLabel !== ""
                        ? displayableQualificationList[index].modeLabel
                        : "NA"}
                    </td>
                    <td className="word-break">
                      {displayableQualificationList[index] &&
                        displayableQualificationList[index].compulsorySubjectsLabel !== null
                        ? displayableQualificationList[index].compulsorySubjectsLabel
                        : "NA"}
                    </td>
                    <td className="word-break">
                      {displayableQualificationList[index] &&
                        displayableQualificationList[index].optionalSubjectsLabel !== null
                        ? displayableQualificationList[index].optionalSubjectsLabel
                        : "NA"}
                    </td>
                    <td className="word-break text-uppercase">
                      {ele ? ele.seatNumber : "NA"}
                    </td>
                    <td className="word-break">
                      {ele && ele.yearOfPassing !== "0" ? ele.yearOfPassing : "NA"}
                    </td>


                    {
                      activeQualificationIndex !== index ? (
                        <td className="word-break">
                          {profileStatus !== true ? (
                            <button
                              onClick={() => setActiveQualificationIndex(index)}
                              data-toggle="tooltip"
                              title="Edit and Delete"
                            >
                              <PiDotsThreeOutlineVerticalFill />
                            </button>
                          ) : (
                            showThreeDots && (
                              <button
                                onClick={() => setActiveQualificationIndex(index)}
                                data-toggle="tooltip"
                                title="Edit and Delete"
                              >
                                <PiDotsThreeOutlineVerticalFill />
                              </button>
                            )
                          )}
                        </td>
                      ) : (
                        <td className="word-break edit_delete_button">
                          {profileStatus !== true ? (
                            <>
                              <i
                                className={`fas fa-pen-to-square edit-icon ${isEditing && isEditingIndex !== index
                                  ? "disabled-link disabled_edit_link"
                                  : "enabled-link"
                                  }`}
                                title={
                                  isEditing && isEditingIndex !== index
                                    ? common.EDIT_DISALLOWED_TOOLTIP
                                    : common.EDIT_TOOLTIP
                                }
                                onClick={() => {
                                  if (!isEditing || isEditingIndex === index) {
                                    editQualificationRow(index, ele);
                                  }
                                }}
                              />
                              <i
                                className={`fas fa-trash edit-icon ${isEditing && isEditingIndex !== index
                                  ? "disabled-link disabled_edit_link"
                                  : "enabled-link"
                                  }`}
                                title={
                                  isEditing && isEditingIndex !== index
                                    ? common.DELETE_DISALLOWED_TOOLTIP
                                    : common.DELETE_TOOLTIP
                                }
                                onClick={() => {
                                  if (!isEditing || isEditingIndex === index) {
                                    setDeleteIndex(index);
                                    setShowModal(true);
                                  }
                                }}
                              />
                            </>
                          ) : (
                            showThreeDots && (
                              <>
                                {canEdit && (
                                  <i
                                    className={`fas fa-pen-to-square edit-icon ${isEditing && isEditingIndex !== index
                                      ? "disabled-link disabled_edit_link"
                                      : "enabled-link"
                                      }`}
                                    title={
                                      isEditing && isEditingIndex !== index
                                        ? common.EDIT_DISALLOWED_TOOLTIP
                                        : common.EDIT_TOOLTIP
                                    }
                                    onClick={() => {
                                      if (!isEditing || isEditingIndex === index) {
                                        editQualificationRow(index, ele);
                                      }
                                    }}
                                  />
                                )}
                                {canDelete && (
                                  <i
                                    className={`fas fa-trash edit-icon ${isEditing && isEditingIndex !== index
                                      ? "disabled-link disabled_edit_link"
                                      : "enabled-link"
                                      }`}
                                    title={
                                      isEditing && isEditingIndex !== index
                                        ? common.DELETE_DISALLOWED_TOOLTIP
                                        : common.DELETE_TOOLTIP
                                    }
                                    onClick={() => {
                                      if (!isEditing || isEditingIndex === index) {
                                        setDeleteIndex(index);
                                        setShowModal(true);
                                      }
                                    }}
                                  />
                                )}
                              </>
                            )
                          )}
                        </td>
                      )
                    }



                    {/* {
                      activeQualificationIndex !== index ? (
                        <td className="word-break">

                          {ele.isLocked !== true && (
                            <button
                              onClick={() => setActiveQualificationIndex(index)}
                              data-toggle="tooltip"
                              title="Edit and Delete"
                            >
                              <PiDotsThreeOutlineVerticalFill />
                            </button>
                          )}
                        </td>
                        
                      ) : (
                       <td className="word-break edit_delete_button">
                        {ele.isLocked !== true && (
                          <>
                            <i
                              className={`fas fa-pen-to-square edit-icon ${isEditing && isEditingIndex !== index
                                ? "disabled-link disabled_edit_link"
                                : "enabled-link"
                                }`}
                              data-toggle="tooltip"
                              title={
                                isEditing && isEditingIndex !== index
                                  ? common.EDIT_DISALLOWED_TOOLTIP
                                  : common.EDIT_TOOLTIP
                              }
                              onClick={() => {
                                if (!isEditing || isEditingIndex === index) {
                                  editQualificationRow(index, ele);
                                }
                              }}
                            />
                            <i
                              className={`fas fa-trash edit-icon ${isEditing && isEditingIndex !== index
                                ? "disabled-link disabled_edit_link"
                                : "enabled-link"
                                }`}
                              id="trash-icon"
                              data-toggle="tooltip"
                              title={
                                isEditing && isEditingIndex !== index
                                  ? common.DELETE_DISALLOWED_TOOLTIP
                                  : common.DELETE_TOOLTIP
                              }
                              onClick={() => {
                                if (!isEditing || isEditingIndex === index) {
                                  setDeleteIndex(index);
                                  setShowModal(true);
                                }
                              }}
                            />
                          </>
                        )}
                      </td>
                      )
                    } */}
                    <td className="word-break w-1 text-center">
                      <img src="/icons/cross.png" width="20" height="20" />
                    </td>
                  </tr>
                );
              }
            })}
          </tbody>
        </table>
      </div>

      {
        qualificationsList && qualificationsList.length === 0 ? (
          <h6 className="text-muted text-center freeze-table">
            {commonLabels.NO_DATA_TO_DISPLAY}
          </h6>
        ) : (
          ""
        )
      }



      {/* Table to show internship  */}



      {
        showInternshipTable && (
          <>
            <h5 className="bottom-dotted-line align-left p-1">
              {qualificationinformation.INTERNSHIP_DETAILS}{" "}
              {qualificationinformation_hindi.INTERNSHIP_DETAILS_hin}
            </h5>
            <br />
            <div className="table-scroll-container" >
              <table className="table table-bordered mb-4 freeze-table">
                <thead>
                  <tr className="qualifcation_table">
                    {qualificationinformation.internshipQualificationHeaderContent?.map(
                      (ele, index) => (
                        <th
                          className={`theadBgColor theadBgColor_qualification text-left ${index < 2 ? "sticky-col" : ""}`}
                          scope="col"
                          key={index}
                        >
                          {ele}
                        </th>
                      )
                    )}
                  </tr>
                </thead>
                <tbody className="f12">
                  {internshipList?.map((ele, index) => {
                    if (!ele.isDelete) {
                      internshipCount++;
                      return (
                        <tr key={index}>
                          <td className="w-1 word-break text-left sticky-col ">{internshipCount}</td>
                          <td className="word-break sticky-col ">{ele
                            ? ele
                              .subject
                            : "NA"}</td>

                          <td className="word-break ">{ele ? ele.qualificationname
                            : "NA"}</td>
                          <td className="word-break ">
                            {ele?.internshipFromDate ? dayjs(getFormattedDate(ele.internshipFromDate)).format(commonLabels.DATE_FORMAT) : "NA"}
                          </td>
                          <td className="word-break ">
                            {ele?.internshipToDate ? dayjs(getFormattedDate(ele.internshipToDate)).format(commonLabels.DATE_FORMAT) : "NA"}
                          </td>
                          <td className="word-break text-left w-20 text-uppercase">{ele?.internshipCollege ?? "NA"}</td>
                          <td className="word-break text-uppercase">{ele?.internshipCertificate ?? "NA"}</td>
                          <td className="word-break ">
                            {ele?.internshipIssueDate ? dayjs(getFormattedDate(ele.internshipIssueDate)).format(commonLabels.DATE_FORMAT) : "NA"}
                          </td>
                          <td className="word-break w-15 text-uppercase">{ele?.internshipIssuedBy ?? "NA"}</td>


                          {/* condition to display buttons and 3 dots */}

                          {
                            activeIntershipIndex !== index ? (
                              <td className="word-break">
                                {profileStatus !== true ? (
                                  <button
                                    onClick={() => setActiveIntershipIndex(index)}
                                    data-toggle="tooltip"
                                    title="Edit and Delete"
                                  >
                                    <PiDotsThreeOutlineVerticalFill />
                                  </button>
                                ) : (
                                  showThreeDotsIntership && (
                                    <button
                                      onClick={() => setActiveIntershipIndex(index)}
                                      data-toggle="tooltip"
                                      title="Edit and Delete"
                                    >
                                      <PiDotsThreeOutlineVerticalFill />
                                    </button>
                                  )
                                )}
                              </td>
                            ) : (
                              <td className="word-break edit_delete_button">
                                {profileStatus !== true ? (
                                  <>
                                    <i
                                      className={`fas fa-pen-to-square edit-icon ${isEditing && isEditingIndex !== index
                                        ? "disabled-link disabled_edit_link"
                                        : "enabled-link"
                                        }`}
                                      data-toggle="tooltip"
                                      title={
                                        isEditing && isEditingIndex !== index
                                          ? common.EDIT_DISALLOWED_TOOLTIP
                                          : common.EDIT_TOOLTIP
                                      }
                                      onClick={() => {
                                        if (!isEditing || isEditingIndex === index) {
                                          editInternshipRow(ele.id, ele);
                                        }
                                      }}
                                    />
                                    <i
                                      className={`fas fa-trash edit-icon ${isEditing && isEditingIndex !== index
                                        ? "disabled-link disabled_edit_link"
                                        : "enabled-link"
                                        }`}
                                      id="trash-icon"
                                      data-toggle="tooltip"
                                      title={
                                        isEditing && isEditingIndex !== index
                                          ? common.DELETE_DISALLOWED_TOOLTIP
                                          : common.DELETE_TOOLTIP
                                      }
                                      onClick={() => {
                                        if (!isEditing || isEditingIndex === index) {
                                          setDeleteInternIndex(ele.id);
                                          setInternShowModal(true);
                                        }
                                      }}
                                    />
                                  </>
                                ) : (
                                  showThreeDotsIntership && (
                                    <>
                                      {canEditIntership && (
                                        <i
                                          className={`fas fa-pen-to-square edit-icon ${isEditing && isEditingIndex !== index
                                            ? "disabled-link disabled_edit_link"
                                            : "enabled-link"
                                            }`}
                                          data-toggle="tooltip"
                                          title={
                                            isEditing && isEditingIndex !== index
                                              ? common.EDIT_DISALLOWED_TOOLTIP
                                              : common.EDIT_TOOLTIP
                                          }
                                          onClick={() => {
                                            if (!isEditing || isEditingIndex === index) {
                                              editInternshipRow(ele.id, ele);
                                            }
                                          }}
                                        />
                                      )}
                                      {canDeleteIntership && (
                                        <i
                                          className={`fas fa-trash edit-icon ${isEditing && isEditingIndex !== index
                                            ? "disabled-link disabled_edit_link"
                                            : "enabled-link"
                                            }`}
                                          id="trash-icon"
                                          data-toggle="tooltip"
                                          title={
                                            isEditing && isEditingIndex !== index
                                              ? common.DELETE_DISALLOWED_TOOLTIP
                                              : common.DELETE_TOOLTIP
                                          }
                                          onClick={() => {
                                            if (!isEditing || isEditingIndex === index) {
                                              setDeleteInternIndex(ele.id);
                                              setInternShowModal(true);
                                            }
                                          }}
                                        />
                                      )}
                                    </>
                                  )
                                )}
                              </td>
                            )
                          }



                          <td className="word-break text-center">
                            <img src="/icons/cross.png" width="20" height="20" alt="Remove Icon" />
                          </td>
                        </tr>
                      );
                    }
                  })}

                </tbody>
              </table>
            </div>
          </>
        )
      }


      {
        showPublicationTable && (
          <>
            <h5 className="bottom-dotted-line align-left p-1">
              {qualificationinformation.PUBLICATION_DETAILS}{" "}
              {qualificationinformation_hindi.PUBLICATION_DETAILS_hin}
            </h5>
            {/* </div> */}
            <br />
            <div className="table-scroll-container" >
              <table className="table table-bordered mb-4 freeze-table overflow-auto">
                <thead>
                  <tr className="qualifcation_table">
                    {qualificationinformation.publicationQualificationHeaderContent &&
                      qualificationinformation.publicationQualificationHeaderContent.map(
                        (ele, index) => (
                          <th
                            scope="col"
                            key={index}
                            className={`theadBgColor theadBgColor_qualification ${index === 1 ? "sticky-col" : ""}`}
                          >
                            {ele}
                          </th>
                        )
                      )}
                  </tr>
                </thead>
                <tbody className="f12">
                  {sortQualificationList(qualificationsList).map((ele, index) => {
                    if (!ele.isDelete && ele.qualificationtypecode === "Pb") {
                      publicationTableCount++;
                      return (
                        <tr key={index}>
                          <td className="w-1 word-break text-center sticky-col">
                            {publicationTableCount}
                          </td>
                          <td className="word-break sticky-col">
                            {displayableQualificationList[index]
                              ? displayableQualificationList[index]
                                .qualificationTypeLabel
                              : "NA"}
                          </td>
                          <td className="word-break">
                            {displayableQualificationList[index]
                              ? displayableQualificationList[index]
                                .qualificationNameLabel
                              : "NA"}
                          </td>
                          <td className="word-break">
                            {ele &&
                              ele.indexingBodyLookupId ?
                              nameOfIndexingBodies(
                                ele.indexingBodyLookupId,
                                nameOfIndexingBodiesList
                              ) : "NA"}
                          </td>
                          <td className="word-break">
                            {ele &&
                              ele.articleTypeLookupId ?
                              articleType(
                                ele
                                  .articleTypeLookupId,
                                getPublicationArticleTypeList
                              ) : "NA"}
                          </td>
                          <td className="word-break text-center">
                            {ele &&
                              isPublicationFirstAuthor(
                                ele.isPublicationFirstAuthor === true ||
                                  ele.isPublicationFirstAuthor === "true"
                                  ? true
                                  : ele.isPublicationFirstAuthor === false ||
                                    ele.isPublicationFirstAuthor === "false"
                                    ? false
                                    : "",
                                BOOLEAN_OPTION
                              )}
                          </td>
                          <td className="word-break">
                            {ele &&
                              ele.publicationAuthorType &&
                              authorType(ele.publicationAuthorType, AUTHOR_TYPES)}
                          </td>
                          <td className="word-break">
                            {ele ? ele.publicationJournalDetails : "NA"}
                          </td>
                          <td className="word-break">
                            {ele ? ele.publicationIssnNo && ele.publicationIssnNo.toUpperCase() : "NA"}
                          </td>
                          <td className="word-break text-center">
                            {ele && ele.publicationYear}
                          </td>
                          <td className="word-break text-center">
                            {ele &&
                              (ele.isImpactIndex20OrMore === true ||
                                ele.isImpactIndex20OrMore === "true"
                                ? "Yes"
                                : ele.isImpactIndex20OrMore === false ||
                                  ele.isImpactIndex20OrMore === "false"
                                  ? "No"
                                  : "")}
                          </td>
                          <td className="word-break ">
                            {ele && ele.publicationPaperTitle.toUpperCase()}
                          </td>
                          <td className="word-break text-center">
                            {ele ?
                              ele.publicationAcceptanceDate &&
                              dayjs(
                                getFormattedDate(ele
                                  .publicationAcceptanceDate)
                              ).format(commonLabels.DATE_FORMAT)
                              : "NA"}
                          </td>
                          <td className="word-break text-center">
                            {
                              ele ?
                                ele
                                  .publicationPublishedDate &&
                                dayjs(
                                  getFormattedDate(ele
                                    .publicationPublishedDate)
                                ).format(commonLabels.DATE_FORMAT)
                                : "NA"}
                          </td>
                          <td className="word-break text-center">
                            {/* {ele ? ele.isPublicationGuide && ele.isPublicationGuide.toUpperCase() : "NA"} */}
                            {ele &&
                              (ele.isPublicationGuide === true ||
                                ele.isPublicationGuide === "true"
                                ? "Yes"
                                : ele.isPublicationGuide === false ||
                                  ele.isPublicationGuide === "false"
                                  ? "No"
                                  : "NA")}

                          </td>
                          {/* <td className="word-break text-center">
                        {ele ? ele.seatNumber.toUpperCase() : "NA"}
                      </td>
                      <td className="word-break text-center">
                        {ele ? ele.yearOfPassing : "NA"}
                      </td> */}

                          {
                            activePublicationIndex !== index ? (
                              <td className="word-break">
                                {profileStatus !== true ? (
                                  <button
                                    onClick={() => setActivePublicationIndex(index)}
                                    data-toggle="tooltip"
                                    title="Edit and Delete"
                                  >
                                    <PiDotsThreeOutlineVerticalFill />
                                  </button>
                                ) : (
                                  showThreeDots && (
                                    <button
                                      onClick={() => setActivePublicationIndex(index)}
                                      data-toggle="tooltip"
                                      title="Edit and Delete"
                                    >
                                      <PiDotsThreeOutlineVerticalFill />
                                    </button>
                                  )
                                )}
                              </td>
                            ) : (
                              <td className="word-break edit_delete_button">
                                {profileStatus !== true ? (
                                  <>
                                    <i
                                      className={`fas fa-pen-to-square edit-icon ${isEditing && isEditingIndex !== index
                                        ? " disabled-link disabled_edit_link"
                                        : ""
                                        }`}
                                      data-toggle="tooltip"
                                      title={
                                        isEditing && isEditingIndex !== index
                                          ? common.EDIT_DISALLOWED_TOOLTIP
                                          : common.EDIT_TOOLTIP
                                      }
                                      onClick={() => {
                                        if (!isEditing || isEditingIndex === index) {
                                          editQualificationRow(index, ele);
                                        }
                                      }}
                                    />

                                    <i
                                      className={`fas fa-trash edit-icon ${isEditing && isEditingIndex !== index
                                        ? " disabled-link disabled-link disabled_edit_link"
                                        : ""
                                        }`}
                                      data-toggle="tooltip"
                                      title={
                                        isEditing && isEditingIndex !== index
                                          ? common.DELETE_DISALLOWED_TOOLTIP
                                          : common.DELETE_TOOLTIP
                                      }
                                      onClick={() => {
                                        if (!isEditing || isEditingIndex === index) {
                                          setDeleteIndex(index);
                                          setShowModal(true);
                                        }
                                      }}
                                    />
                                  </>
                                ) : (
                                  showThreeDots && (
                                    <>
                                      {canEdit && (
                                        <i
                                          className={`fas fa-pen-to-square edit-icon ${isEditing && isEditingIndex !== index
                                            ? " disabled-link disabled_edit_link"
                                            : ""
                                            }`}
                                          data-toggle="tooltip"
                                          title={
                                            isEditing && isEditingIndex !== index
                                              ? common.EDIT_DISALLOWED_TOOLTIP
                                              : common.EDIT_TOOLTIP
                                          }
                                          onClick={() => {
                                            if (!isEditing || isEditingIndex === index) {
                                              editQualificationRow(index, ele);
                                            }
                                          }}
                                        />
                                      )}
                                      {canDelete && (
                                        <i
                                          className={`fas fa-trash edit-icon ${isEditing && isEditingIndex !== index
                                            ? " disabled-link disabled-link disabled_edit_link"
                                            : ""
                                            }`}
                                          data-toggle="tooltip"
                                          title={
                                            isEditing && isEditingIndex !== index
                                              ? common.DELETE_DISALLOWED_TOOLTIP
                                              : common.DELETE_TOOLTIP
                                          }
                                          onClick={() => {
                                            if (!isEditing || isEditingIndex === index) {
                                              setDeleteIndex(index);
                                              setShowModal(true);
                                            }
                                          }}
                                        />
                                      )}
                                    </>
                                  )
                                )}
                              </td>
                            )
                          }

                          <td className="word-break text-center">
                            <img src="/icons/cross.png" width="20" height="20" />{" "}
                            {/* <img src="/icons/tickIcon.png" width="20" height="20" /> */}
                          </td>
                        </tr>
                      );
                    }
                  })}
                </tbody>
              </table>
            </div>
          </>
        )
      }




      <Modal
        show={showModal}
        onHide={() => {
          setShowModal(false);
        }}
        backdrop="static"
      >
        <Modal.Header className="custom-modal-header logout_heading">
          <Modal.Title className="logout_title">
            {qualificationinformation.DELETE_QUALIFICATION_MODAL_TITLE}
          </Modal.Title>
          <button
            type="button"
            className="ms-auto logout_close"
            aria-label="Close"
            onClick={() => setShowModal(false)}
          >X</button>
        </Modal.Header>
        <Modal.Body>
            {qualificationinformation.DELETE_QUALIFICATION_CONFIRMATION_MESSAGE}
         
        </Modal.Body>
        <Modal.Footer>
          <button
            className="btn btn-secondary"
            onClick={() => {
              setShowModal(false);
            }}
          >
            {common.CANCEL}
          </button>
          <button className=" btn btn-primary custom_button " onClick={modalConfirm}>
            {common.CONFIRM}
          </button>
        </Modal.Footer>
      </Modal>





      <Modal
        show={internShowModal}
        onHide={() => {
          setInternShowModal(false);
        }}
        backdrop="static"
      >
        <Modal.Header className="custom-modal-header logout_heading">
          <Modal.Title>
            {qualificationinformation.DELETE_INTERNSHP_MODAL_TITLE}
          </Modal.Title>
          <button
            type="button"
            className="ms-auto logout_close"
            aria-label="Close"
            onClick={() => setInternShowModal(false)}
          >X</button>
        </Modal.Header>
        <Modal.Body>
            {qualificationinformation.DELETE_INTERNSHIP_CONFIRMATION_MESSAGE}
         
        </Modal.Body>
        <Modal.Footer>
          <button
            className="btn btn-secondary"
            onClick={() => {
              setInternShowModal(false);
            }}
          >
            {common.CANCEL}
          </button>
          <button className=" btn btn-primary custom_button " onClick={modalConfirmInternship}>
            {common.CONFIRM}
          </button>
        </Modal.Footer>
      </Modal>





    </div >

  );
};

export default QualificationTabTable;
